export default __webpack_public_path__ + "static/t02-79eb2e98f232bbf2b40bba2be4f1fed6.jpg";